import { all } from "redux-saga/effects";
import dataGridSaga from "./dataGrid/DataGridSaga";

export default function* startSagas() {
    yield all([
        dataGridSaga()
    ]);
}